import { BrowserRouter, Switch, Route } from "react-router-dom";
import SSO from "./pages/SSO/index";
import Login from "./pages/SSO/Login";
import SSOError from "./pages/SSO/SSOError";
import NotFound from "./common/NotFound";
import LearnMore from "./pages/LearnMore";
import ClearSession from "./common/ClearSession";

const Router = (props: any) => {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/sso/:app" children={<SSO />} />
                <Route path="/login" component={Login} />
                <Route path="/learn-more" component={LearnMore} />
                <Route path="/sso-error" children={<SSOError />} />
                <Route path="/clear-session" children={<ClearSession />} />
                <Route component={NotFound} />
            </Switch>
        </BrowserRouter>
    );
}

export default Router;